const parametroSistema = {
    obter: function (nome, callback) {

        var p = null;

        if (this.existeParametro(nome)) {

            p = this.obterParametro(nome);

            if (callback) {
                callback(p);
            }

            return p;
        }

        var async = typeof callback != "undefined";

        global.ajax({
            url: "/Comum/ObterParametro",
            type: "post",
            async: async,
            data: {
                nome: nome
            },
            success: function (data) {

                p = { Nome: nome, Valor: data };

                parametroSistema.adicionarParametros([p]);

                if (callback) {
                    callback(p);
                }
            }
        });

        return p;
    },

    adicionarParametros: function (data) {

        if (!data) {
            return;
        }

        var self = this;

        $.each(data,
            function () {

                if (!self.parametros) {
                    self.parametros = new Array();
                }

                if (!self.existeParametro(this.Nome)) {
                    self.parametros.push(this);
                }

            });
    },

    existeParametro: function (nome) {
        if (!this.parametros) {
            return false;
        }
        var p = global.where(this.parametros, { Nome: nome });
        return p && p.length > 0;
    },

    obterParametro: function (nome) {
        var p = global.where(this.parametros, { Nome: nome });
        return p && p.length > 0 ? p[0] : null;
    },

    aplicarParametros: function (region) {

        if (!region) {
            return;
        }

        var $region = region;

        if (!(region instanceof jQuery)) {
            $region = $(region);
        }

        var parametros = [];
        var parametrosPai = [];
        var nomes = [];
        var self = this;

        $("[parametro]", $region).each(function () {

            var jsonData = JSON.parse($(this).attr("parametro"));

            if (jsonData) {

                jsonData.el = this;
                var $elPai = $(this).parents("[parametro-pai]");

                if ($elPai.length > 0) {
                    var jsonDataPai = JSON.parse($elPai.attr("parametro-pai"));

                    if (jsonDataPai) {

                        var parametroPai = global.where(parametrosPai, { nome: jsonDataPai.nome });

                        if (parametroPai && parametroPai.length > 0) {
                            jsonDataPai = parametroPai[0];
                        } else {
                            jsonDataPai.el = $elPai[0];
                            parametrosPai.push(jsonDataPai);
                        }
                        jsonDataPai.parametros = jsonData.parametros ? jsonData.parametros : new Array();
                        jsonDataPai.parametros.push(jsonData);
                    }
                }

                parametros.push(jsonData);
                var arr = jsonData.parametros ? jsonData.parametros : [jsonData];

                $.each(arr,
                    function () {
                        if (!this.naoVerificar &&
                            !self.existeParametro(this.nome) &&
                            !global.isInArray(this.nome, nomes)) {
                            nomes.push(this.nome);
                        }
                    });
            }
        });

        var aposAplicadoCallback = $.proxy(this.aposAplicado, this, parametrosPai);
        var callback = $.proxy(this.aplicar, this, region, parametros, aposAplicadoCallback);

        if (nomes.length > 0) {
            global.ajax({
                url: "/Comum/ObterParametros",
                type: "post",
                contentType: "application/json",
                blockUI: false,
                data: global.toJSONString({
                    parametros: nomes
                }),
                success: function (data) {
                    if (data) {
                        self.adicionarParametros(data);
                        callback(self.parametros);
                    }
                }
            });
        } else {

            callback(this.parametros);
        }
    },

    aposAplicado: function (parametrosPai) {

        if (!parametrosPai || parametrosPai.length == 0) {
            return;
        }

        $.each(parametrosPai,
            function () {
                if (this.parametros) {
                    var visivel = false;
                    $.each(this.parametros,
                        function () {

                            if ($(this.el).css("display") != "none") {
                                visivel = true;
                                return false;
                            }
                        });

                    if (!visivel) {
                        $(this.el).hide();
                    }
                }

            });
    },

    aplicar: function (region, parametros, aposAplicadoCallback, data) {

        if (!region || !data || !parametros) {
            return;
        }

        var $region = region;

        if (!(region instanceof jQuery)) {
            $region = $(region);
        }
        $.each(data,
            function () {
                var valor = this.Valor;
                var p = global.where(parametros, { nome: this.Nome });
                if (p) {
                    $.each(p,
                        function () {
                            this.valor = valor;
                            parametroSistema.aplicarElemento(this);
                        });
                }
            });

        var self = this;

        $.each(parametros,
            function () {

                if (this.parametros) {
                    self.aplicarRegra(this);
                }

            });

        if (aposAplicadoCallback) {
            aposAplicadoCallback();
        }

    },

    aplicarRegra: function (parametro) {

        if (!parametro || !parametro.parametros || parametro.parametros.length == 0) {
            return;
        }

        var $el = $(parametro.el);

        if (!$el || $el.length == 0) {
            return;
        }

        var self = this;
        var val = parametro.operador == "and";

        $.each(parametro.parametros,
            function () {

                var p = self.obterParametro(this.nome);

                if (p) {

                    if (!p.Valor) {
                        p.Valor = "";
                    }

                    var valores = p.Valor.split(",");

                    var paramAtual = this;

                    $.each(valores,
                        function () {

                            var result = this == paramAtual.valor;

                            switch (parametro.operador) {
                                case "and":
                                    val = val && result;

                                    if (!val) {
                                        return false;
                                    }

                                    break;
                                case "or":

                                    if (result) {
                                        val = true;
                                        return false;
                                    }

                                    break;
                            }
                        });

                    switch (parametro.operador) {
                        case "and":

                            if (!val) {
                                return false;
                            }

                            break;

                        case "or":

                            if (val) {
                                return false;
                            }

                            break;
                    }


                }

            });


        if (val) {

            switch (parametro.acao) {
                case "mostrar":
                    if ($el.attr('permitirmostrar') == undefined || $el.attr('permitirmostrar') == 'true') {
                        $el.show();
                    }
                    break;
                case "esconder":
                    $el.hide();
                    break;
                case "remover":
                    $el.remove();
                    break;
                case "desabilitar":
                    $el.prop("disabled", true);
                    break;
                case "habilitar":

                    if (this.allowEnable($el)) {
                        $el.prop("disabled", false);
                    }
                    break;
            }
        }
    },

    allowEnable: function (element) {

        var allowEnable = element.attr("allowenable");
        return allowEnable == undefined || allowEnable;
    },

    aplicarElemento: function (data) {

        if (!data) {
            return;
        }

        var self = this;

        var $el = $(data.el);

        if (!$el || $el.length == 0) {
            return;
        }

        var valoresEsconder = data.valorEsconder ? data.valorEsconder.split(",") : null;

        if (valoresEsconder && valoresEsconder.length > 0) {
            $.each(valoresEsconder,
                function () {

                    var valor = this;

                    if (valor == "undefined") {
                        valor = undefined;
                    }

                    if (valor == "null") {
                        valor = null;
                    }

                    if (valor && data && data.valor && (valor.toLowerCase() == data.valor.toLowerCase())) {
                        $el.attr("parametro-aplicado", "esconder");
                        $el.hide();
                    }
                });
        }

        var valoresMostrar = data.valorMostrar ? data.valorMostrar.split(",") : null;

        if (valoresMostrar && valoresMostrar.length > 0) {
            $.each(valoresMostrar,
                function () {

                    var valor = this;

                    if (valor == "undefined") {
                        valor = undefined;
                    }

                    if (valor == "null") {
                        valor = null;
                    }

                    if (valor && data && data.valor && (valor.toLowerCase() == data.valor.toLowerCase())) {
                        if ($el.attr('permitirmostrar') == undefined || $el.attr('permitirmostrar') == 'true') {
                            $el.attr("parametro-aplicado", "mostrar");
                            $el.show();
                        }
                    }
                });
        }

        var valoresDesabilitar = data.valorDesabilitar ? data.valorDesabilitar.split(",") : null;

        if (valoresDesabilitar && valoresDesabilitar.length > 0) {
            $.each(valoresDesabilitar,
                function () {

                    var valor = this;

                    if (valor == "undefined") {
                        valor = undefined;
                    }

                    if (valor == "null") {
                        valor = null;
                    }

                    var arrValor = data && data.valor ? data.valor.split(",") : null;

                    if ($.isArray(arrValor)) {
                        $.each(arrValor,
                            function () {
                                if (valor && valor.toLowerCase() == this.toLowerCase()) {
                                    $el.attr("parametro-aplicado", "desabilitado");

                                    if (self.allowEnable($el)) {
                                        $el.prop("disabled", true);
                                    }

                                    return false;
                                }
                            });
                    } else if (valor == arrValor) {
                        $el.attr("parametro-aplicado", "desabilitado");

                        if (self.allowEnable($el)) {
                            $el.prop("disabled", true);
                        }
                    }

                });
        }

        var valoresRemover = data.valorRemover ? data.valorRemover.split(",") : null;

        if (valoresRemover && valoresRemover.length > 0) {
            $.each(valoresRemover,
                function () {

                    var valor = this;

                    if (valor == "undefined") {
                        valor = undefined;
                    }

                    if (valor == "null") {
                        valor = null;
                    }

                    var arrValor = data && data.valor ? data.valor.split(",") : null;

                    if ($.isArray(arrValor)) {
                        $.each(arrValor,
                            function () {
                                if (valor == this || ((valor && this) && valor.toLowerCase() == this.toLowerCase())) {
                                    $el.remove();
                                    return false;
                                }
                            });
                    } else if (valor == arrValor) {
                        $el.remove();
                    }

                });
        }

        var valoresHabilitar = data.valorHabilitar ? data.valorHabilitar.split(",") : null;

        if (valoresHabilitar && valoresHabilitar.length > 0) {
            $.each(valoresHabilitar,
                function () {

                    var valor = this;

                    if (valor == "undefined") {
                        valor = undefined;
                    }

                    if (valor == "null") {
                        valor = null;
                    }

                    var arrValor = data && data.valor ? data.valor.split(",") : null;

                    if ($.isArray(arrValor)) {
                        $.each(arrValor,
                            function () {
                                if (valor && valor.toLowerCase() != this.toLowerCase()) {
                                    $el.attr("parametro-aplicado", "desabilitado");

                                    if (self.allowEnable($el)) {
                                        $el.prop("disabled", true);
                                    }

                                    return false;
                                }
                            });
                    } else if (valor != arrValor) {
                        $el.attr("parametro-aplicado", "desabilitado");

                        if (self.allowEnable($el)) {
                            $el.prop("disabled", true);
                        }
                    }

                });
        }


    }


};

window.parametroSistema = parametroSistema

export {
    parametroSistema
}